import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Settings } from "../../models/settings.model";

export const settingsActions = createActionGroup({
    source: "Settings",
    events: {
        'Get Settings': emptyProps(),
        'Get Settings Success': props<{payload: Settings}>()
    }
})